import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie-player'

import AiTravelTranslateBtn from 'pages/aiTalk/components/AiTravelTranslateBtn'
import ButtonAudio from 'pages/aiTalk/components/ButtonAudio'

import { YANADOO_CDN_HOST } from 'common/config'

import s from './Chat.module.scss'

const defaultOptions = {
  loop: true,
  play: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export default function MessageUser({ message, userSeq }) {
  const [translateText, setTranslateText] = useState(null)
  const [transLoading, setTransLoading] = useState(false)
  const [translated, setTranslated] = useState(false)

  const [lottieData, setLottieData] = useState(null)

  useEffect(() => {
    const fetchLottieData = async () => {
      try {
        const response = await fetch(`${YANADOO_CDN_HOST}/lottie/aitalk-loading-dots.json`)
        const jsonData = await response.json()
        setLottieData(jsonData)
      } catch (error) {
        console.error('Lottie 데이터를 불러오는데 실패했습니다:', error)
      }
    }
    fetchLottieData()
  }, [])

  return (
    <>
      <div className={`${s.message} ${s.userMessage}`}>
        <p>{message}</p>
        <div className={s.btnGroup}>
          <ButtonAudio text={message} yellow userSeq={userSeq} />
          <AiTravelTranslateBtn
            type={'USER'}
            message={message}
            translated={translated}
            translateText={translateText}
            setTransLoading={setTransLoading}
            setTranslated={setTranslated}
            setTranslateText={setTranslateText}
            userSeq={userSeq}
          />
        </div>
      </div>
      {transLoading && !translateText && (
        <p className={s.translateText}>
          <div className={s.lottieBox}>
            <Lottie {...defaultOptions} animationData={lottieData} />
          </div>
        </p>
      )}
      {translateText && translated && <p className={s.translateText}>{translateText}</p>}
    </>
  )
}
